import React from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import { MenuItem } from "Components/Base/Inputs/MenuItem";
import { Select } from "Components/Base/Inputs/Select";
import { Box } from "Components/Base/Layout/Box";
import { MetadataRequiredMark } from "lib/components/ItemMetadataFields/fields/shared";

const DropdownField = ({ field, fieldState, disabled, onChange }) => {
  const { fieldError, fieldId, labelText, required, value } = fieldState;
  const options = Array.isArray(field.options) ? field.options : [];
  const invalidSelect = Boolean(fieldError) || (required && !value);

  return (
    <Box mb={1.25}>
      <InputLabel id={`${fieldId}-label`} htmlFor={fieldId}>
        {labelText}
        {required ? <MetadataRequiredMark /> : null}
      </InputLabel>
      <Select
        id={fieldId}
        labelId={`${fieldId}-label`}
        displayEmpty
        fullWidth
        disabled={disabled}
        value={value}
        error={Boolean(fieldError)}
        onChange={(event) => onChange(field.id, event.target.value)}
        inputProps={{
          "aria-required": required ? "true" : "false",
          "aria-invalid": invalidSelect ? "true" : "false",
        }}
      >
        <MenuItem value="">
          <em>—</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      {fieldError ? (
        <Typography
          component="p"
          variant="body2"
          color="error"
          role="alert"
          sx={{ mt: 0.5 }}
        >
          {fieldError}
        </Typography>
      ) : null}
    </Box>
  );
};

export default DropdownField;
